// ** Third Party Components
import Cookies from "js-cookie";

// ** Config
import configGlobal from "configuration";

export const updateViewTypeCookie = (key, value) => {
	const { cookieName, cookieOptionsJsCookie } = configGlobal.viewTypes;

	try {
		const existingCookie = Cookies.get(cookieName);
		const existingViewTypes = existingCookie
			? JSON.parse(existingCookie)
			: {};

		const updatedViewTypes = {
			...existingViewTypes,
			[key]: value,
		};

		Cookies.set(
			cookieName,
			JSON.stringify(updatedViewTypes),
			cookieOptionsJsCookie,
		);
	} catch (error) {
		// ** If there is an error, do nothing.
	}
};
